import { breakpoints, styled } from 'styles';

export const HeaderWrapper = styled.div`
  margin-top: 15px;
  margin-bottom: 25px;

  @media (max-width: ${breakpoints.md}) {
    margin-bottom: 10px;
  }
`;

export const DirectWrapper = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;

  @media (max-width: ${breakpoints.md}) {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

export const InfoWrapper = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;

  @media (max-width: ${breakpoints.md}) {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

export const AnalysisWrapper = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;

  @media (max-width: ${breakpoints.md}) {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;
